(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gk-figma-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function getSlidePositions(track, slides){
    var trackRect=track.getBoundingClientRect();
    return Array.prototype.map.call(slides,function(slide){
      return slide.getBoundingClientRect().left-trackRect.left+track.scrollLeft;
    });
  }

  function moveHero(track, dir){
    var slides=track.querySelectorAll('.gkf-hero-promo');
    if(!slides.length) return;

    var positions=getSlidePositions(track,slides);
    var current=0;
    var best=Infinity;

    positions.forEach(function(pos,index){
      var distance=Math.abs(pos-track.scrollLeft);
      if(distance<best){
        best=distance;
        current=index;
      }
    });

    var targetIndex=current+dir;
    if(targetIndex>=slides.length) targetIndex=0;
    if(targetIndex<0) targetIndex=slides.length-1;

    track.scrollTo({
      left:positions[targetIndex],
      behavior:'smooth'
    });
  }

  document.addEventListener('click',function(event){
    var button=event.target.closest('[data-gkf-hero-prev],[data-gkf-hero-next]');
    if(!button) return;

    var section=button.closest('.gkf-hero');
    if(!section) return;

    var track=section.querySelector('[data-gkf-hero-track]');
    if(!track) return;

    event.preventDefault();
    event.stopPropagation();
    moveHero(track,button.hasAttribute('data-gkf-hero-next') ? 1 : -1);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
